var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

import React from 'react';
import PropTypes from 'prop-types';
import Element from './Element';

function fixUncontrolledValue(value) {
  return typeof value === 'undefined' || value === null ? '' : value;
}

var Input = function (_Element) {
  _inherits(Input, _Element);

  function Input() {
    var _temp, _this, _ret;

    _classCallCheck(this, Input);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Element.call.apply(_Element, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  Input.prototype.getValue = function getValue() {
    return fixUncontrolledValue(_Element.prototype.getValue.call(this));
  };

  Input.prototype.onChange = function onChange(evn) {
    var _this2 = this;

    var target = evn.target;

    var value = target.value;

    if (target.type === 'checkbox') {
      value = !!target.checked;
    } else if (target.type === 'radio' && target.checked) {
      value = this.props.value;
    } else if (target.type === 'number') {
      var fixedValue = value.replace(',', '.').replace(' ', '');

      // fix decimal numbers
      var numberValue = Number(fixedValue);
      if (numberValue.toString() === fixedValue) {
        value = numberValue;
      }
    }

    var type = this.props.type;


    if (type === 'checkbox' || type === 'radio') {
      setTimeout(function () {
        _this2.setValue(value);
        var onChange = _this2.props.onChange;


        if (typeof onChange === 'function') {
          onChange(evn);
        }
      }, 0);
    } else {
      this.setValue(value);
      var onChange = this.props.onChange;

      if (typeof onChange === 'function') {
        onChange(evn);
      }
    }
  };

  Input.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
    this.clearTimeout();
  };

  Input.prototype.clearTimeout = function (_clearTimeout) {
    function clearTimeout(_x) {
      return _clearTimeout.apply(this, arguments);
    }

    clearTimeout.toString = function () {
      return _clearTimeout.toString();
    };

    return clearTimeout;
  }(function (sendValue) {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }

    // TODO validate this
    if (sendValue && this.props.value !== this.getValue()) {
      this.notifyParent(this.getValue(), this, sendValue);
    }
  });

  Input.prototype.componentWillUnmount = function componentWillUnmount() {
    _Element.prototype.componentWillUnmount.call(this);
    this.clearTimeout();
  };

  Input.prototype.notifyParent = function notifyParent(value, component, force) {
    var _this3 = this;

    var type = this.props.type;

    var debounce = this.getDebounce();

    if (!this.focused || !debounce || type === 'checkbox' || type === 'radio') {
      _Element.prototype.notifyParent.call(this, value, component);
      return;
    }

    this.clearTimeout();

    if (force) {
      _Element.prototype.notifyParent.call(this, value, component, force);
      return;
    }

    this.timeoutId = setTimeout(function () {
      _this3.timeoutId = null;
      _Element.prototype.notifyParent.call(_this3, value, component);
    }, debounce);
  };

  Input.prototype.getClassName = function getClassName() {
    return this.props.className;
  };

  Input.prototype.getDebounce = function getDebounce() {
    var debounce = this.props.debounce;

    if (typeof debounce !== 'undefined') {
      return debounce;
    }

    return this.getForm().props.debounce;
  };

  Input.prototype.getGroupName = function getGroupName(group) {
    if (!group) {
      return undefined;
    }

    return this.getPathByName(group);
  };

  Input.prototype.render = function render() {
    var _this4 = this;

    var _props = this.props,
        name = _props.name,
        group = _props.group,
        type = _props.type,
        debounce = _props.debounce,
        originalValue = _props.value,
        rest = _objectWithoutProperties(_props, ['name', 'group', 'type', 'debounce', 'value']);

    var value = this.getValue();

    var checked = type === 'checkbox' && value || type === 'radio' && value === originalValue;

    if (type === 'radio' && originalValue) {
      value = originalValue;
    }

    var isCheckbox = type === 'checkbox' || type === 'radio';
    var isRadio = type === 'radio';
    var newName = isRadio ? this.getGroupName(group) : undefined;

    return React.createElement('input', _extends({}, rest, {
      name: newName,
      className: this.getClassName(),
      type: type,
      value: value,
      checked: isCheckbox ? checked : undefined,
      onChange: function onChange() {
        return _this4.onChange.apply(_this4, arguments);
      },
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      onKeyPress: this.onKeyPress
    }));
  };

  return Input;
}(Element);

Input.propTypes = _extends({}, Element.propTypes, {
  className: PropTypes.string,
  style: PropTypes.object,
  autoComplete: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  debounce: PropTypes.number,
  group: PropTypes.string
});
Input.defaultProps = {
  autoComplete: 'off',
  type: 'text',
  group: undefined
};
Input.contextTypes = _extends({}, Element.contextTypes);

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.onKeyPress = function (evn) {
    if (evn.key === 'Enter') {
      _this5.clearTimeout(true);
    }
  };

  this.onFocus = function () {
    var onFocus = _this5.props.onFocus;


    _this5.focused = true;

    if (onFocus) {
      onFocus.apply(undefined, arguments);
    }
  };

  this.onBlur = function () {
    var onBlur = _this5.props.onBlur;


    _this5.focused = false;
    _this5.clearTimeout(true);

    if (onBlur) {
      onBlur.apply(undefined, arguments);
    }
  };
};

export default Input;
//# sourceMappingURL=Input.js.map